// components/EmptyProducts.jsx - Empty State Component
import React from 'react';

const EmptyProducts = () => {
  return (
    <div className='empty-products'>
      <p>محصولی در سبد خرید وجود ندارد</p>
    </div>
  );
};

export default EmptyProducts;
